/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useDispatch } from 'react-redux';
import { trackEvent } from '../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { emitCustomTrackingEvent } from '../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';

const useExperimentServiceTracking = () => {
    const dispatch = useDispatch();

    // track GA4 events
    const trackGA4Experiments = ({ experiments, eventAction = 'Impression' }) => {
        if (!experiments || !experiments.length) return;

        experiments.forEach((experiment) => {
            dispatch(trackEvent({
                eventCategory: 'Experiment',
                eventAction,
                eventName: experiment.campaignName,
                eventLabel: experiment.variant.toLowerCase() === 'control'
                    ? experiment.variant
                    : experiment?.name,
                feature_detail: experiment.variant.toLowerCase() === 'control'
                    ? experiment.variant
                    : experiment?.name,
                feature_element: experiment.campaignName,
                feature_category: 'Experiment',
                experiment_id: experiment?.campaignId,
            }));
        });
    };

    // track clickstream events
    const trackClickStreamExperiments = ({
        experiments,
        action = 'Impression',
        ...rest
    }) => {
        if (!experiments || !experiments.length) return;

        dispatch(emitCustomTrackingEvent({
            experiments,
            eventSubType: 'campaign-tracking',
            action,
            ...rest,
        }));
    };

    return {
        trackGA4Experiments,
        trackClickStreamExperiments,
    };
};

export default useExperimentServiceTracking;
